import React from 'react'

import ListItem from '@components/list-item/list-item.component'

import useStyles from './engagement-list.style'

const EngagementList = ({ engagements, personalAccessCode }) => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.title}>
        <span>Open Engagements</span>
      </div>
      <ul className={classes.list}>
        {engagements.map((engagement) => {
          return (
            <ListItem
              key={`engagement-${engagement.id}`}
              title={engagement.message_text}
              to={`/${personalAccessCode}/engage/${engagement.id}`}
            />
          )
        })}
      </ul>
    </div>
  )
}

export default EngagementList
